@if (siteProjects$ | async; as projects) {
  @if (projects.length > 0) {
    <div class="calendar-shell calendar-shell--modern">
      <table>
        @if (!skipHeader()) {
          <tr class="header">
            @if (showSite()) {
              <td>
                <div class="phase-name">
                  {{ 'calendarPage.site' | translate }}
                </div>
              </td>
            }
            <td>
              <div class="phase-name">
                {{ 'calendarPage.phase' | translate }}
              </div>
            </td>
            <td>
              <div class="phase-name">
                {{ 'calendar.site.area' | translate }}
              </div>
            </td>
            @if (['manager'].includes(role())) {
              <td>
                <div class="phase-name">
                  {{ 'calendar.site.contractor' | translate }}
                </div>
              </td>
            }
            @if (viewSegment() === 'day') {
              @for (day of days(); track day.date) {
                <td [class.today]="day.isToday"
                  [class.weekend]="day.isWeekend">
                  <div class="item item--header">
                    <span>{{ day.date | date:'d.M.' }}</span>
                    @if (day.isToday) {
                      <span class="today-indicator">Tänään</span>
                    }
                  </div>
                </td>
              }
            } @else {
              @for (week of weeks(); track week.dateString) {
                <td [class.today]="week.isToday">
                  <div class="item item--header">
                    <span>{{ week.dateString }}</span>
                    @if (week.isToday) {
                      <span class="today-indicator">Tämä viikko</span>
                    }
                  </div>
                </td>
              }
            }
          </tr>
        }
        @for (project of projects; track project.guid) {
          @for (period of project.periods$ | async; track $index) {
            <tr [class.has-site]="showSite()">
              @if (showSite()) {
                <td class="link tw:cursor-pointer"
                  (click)="onSite(site().guid)">
                  <div class="phase-name">
                    {{ site().project }}
                  </div>
                </td>
              }
              <td class="link tw:cursor-pointer"
                (click)="editPeriod(project, period, site())">
                <div class="phase-name">
                  {{ period.name }}<br />
                  <ion-note>{{ project.name }}</ion-note>
                </div>
              </td>
              <td class="link tw:cursor-pointer"
                (click)="showAreas(period)">
                @if (period.areas?.length > 3) {
                  {{ period.areas.length }} {{ 'room.selected' | translate }}
                } @else {
                  {{ period.areaNames }}
                }
              </td>
              @if (['manager'].includes(role())) {
                <td>
                  @if (period.contractor$ | async; as contractor) {
                    {{ contractor.name }}
                  }
                </td>
              }
              @if (viewSegment() === 'day') {
                @for (day of days(); track day.date) {
                  <td class="link tw:cursor-pointer"
                    [class.today]="day.isToday"
                    [class.weekend]="day.isWeekend"
                    [class.checked]="['on', 'start', 'end'].includes(getPeriodValue(period, day.date))"
                    [class.start]="getPeriodValue(period, day.date) === 'start'"
                    [class.end]="getPeriodValue(period, day.date) === 'end'"
                    (click)="editPeriod(project, period, site())">
                    @if (['on', 'start', 'end'].includes(getPeriodValue(period, day.date))) {
                      <div class="checked"></div>
                    }
                    <div class="item"></div>
                  </td>
                }
              } @else {
                @for (week of weeks(); track week.dateString) {
                  <td class="link tw:cursor-pointer"
                    [class.today]="week.isToday"
                    [class.checked]="['on', 'start', 'end'].includes(getPeriodValue(period, week.date))"
                    [class.start]="getPeriodValue(period, week.date) === 'start'"
                    [class.end]="getPeriodValue(period, week.date) === 'end'"
                    (click)="editPeriod(project, period, site())">
                    @if (['on', 'start', 'end'].includes(getPeriodValue(period, week.date))) {
                      <div class="checked"></div>
                    }
                    <div class="item"></div>
                  </td>
                }
              }
            </tr>
          }
          <!-- Deprecated -->
          @for (period of project.periods; track $index) {
            <tr [class.has-site]="showSite()">
              @if (showSite()) {
                <td class="link tw:cursor-pointer"
                  (click)="onSite(site().guid)">
                  <div class="phase-name">
                    {{ site().project }}
                  </div>
                </td>
              }
              <td class="link tw:cursor-pointer"
                (click)="onProject(site().guid, project.guid)">
                <div class="phase-name">
                  {{ project.name }}
                </div>
              </td>
              <td class="link tw:cursor-pointer"
                (click)="onSite(site().guid)">
                <div class="phase-name">
                  {{ period.name }}
                </div>
              </td>
              @for (day of days(); track day.date) {
                <td class="link tw:cursor-pointer"
                  [class.today]="day.isToday"
                  [class.weekend]="day.isWeekend">
                  <div class="item"></div>
                </td>
              }
            </tr>
          }
        }
      </table>
    </div>
  } @else if (showEmpty()) {
    <div class="empty ion-margin">
      {{ 'calendar.noItems' | translate }}
    </div>
  }
}